import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

import styles from '../styles/Formula.module.css';

interface Props {
  /**
   * Operator name that will be displayed.
   */
  name: string;

  /**
   * Action to execute when the operator box is clicked.
   * Operator looks disabled when this is undefined.
   */
  onClick: React.MouseEventHandler | undefined;
  onMouseOver: React.MouseEventHandler | undefined;
  onMouseLeave: React.MouseEventHandler | undefined;
}

/**
 * Render the operator of a connective.
 */
class Operator extends Component<Props> {
  static defaultProps = {
    onClick: undefined,
    onMouseOver: undefined,
    onMouseLeave: undefined
  };

  render() {
    return (
      <div className={classNames(styles.operator)}>
        <div
          className={classNames(styles.text, {
            [styles.active]: this.props.onClick !== undefined
          })}
          onMouseEnter={this.props.onMouseOver}
          onMouseLeave={this.props.onMouseLeave}
          onClick={this.props.onClick}
        >
          <Typography align="center" inline>
            {this.props.name}
          </Typography>
        </div>
      </div>
    );
  }
}

export default Operator;
